import { cn } from '@/utils/cn';

interface PageShellProps {
  children: React.ReactNode;
  maxWidth?: 'md' | 'lg' | 'xl' | '2xl' | '5xl' | '6xl' | '7xl';
  className?: string;
}

const widthMap: Record<NonNullable<PageShellProps['maxWidth']>, string> = {
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '2xl': 'max-w-2xl',
  '5xl': 'max-w-5xl',
  '6xl': 'max-w-6xl',
  '7xl': 'max-w-7xl',
};

/**
 * 常规内容页的滚动容器：接管 Layout main 留给页面的 100% 高度，
 * 内部 y 轴滚动；页面内容统一居中并加内边距。
 * 审核台这种需要左右独立滚动的页面不要用这个，自行处理。
 */
export function PageShell({ children, maxWidth = '6xl', className }: PageShellProps) {
  return (
    <div className={cn('h-full overflow-y-auto', className)}>
      <div className={cn('mx-auto px-4 py-6 lg:px-8', widthMap[maxWidth])}>{children}</div>
    </div>
  );
}
